import React from "react"
import { Link } from "gatsby"
import styled from "styled-components/macro"
import MoreInfo from "./MoreInfo"
import PhoneIcon from "../../images/iconmonstr-phone-6.svg"
import MailIcon from "../../images/mail-svgrepo-com.svg"
import ContactBar from "../ContactBars/ContactBar"
import Button from "../Button/Button"
import useFacilityData from "../../hooks/useFacilityData.ts"

const MoreInfoContactStyles = styled.section`
  .ContactBar,
  .Button {
    margin-left: 0;
  }
  .ContactBar {
    margin-bottom: 15px;
  }
  @media screen and (min-width: 790px) {
    .ContactBar {
      margin-bottom: 0;
    }
    .Button {
      margin-left: 25px;
    }
  }
`

const MoreInfoContact = () => {
  const facilityData = useFacilityData()

  const phone = facilityData.sanityFacility.facilityObj.facilityInfo.phone

  return (
    <MoreInfoContactStyles>
      <MoreInfo title="Find Out More" id="ContactBox">
        <ContactBar icon={<PhoneIcon />}>{phone}</ContactBar>
        <Button
          icon={<MailIcon />}
          size="lg"
          element={Link}
          to="/#HomePage-contact"
        >
          Contact Us
        </Button>
      </MoreInfo>
    </MoreInfoContactStyles>
  )
}

export default MoreInfoContact
